/**
 * @generated SignedSource<<5c9ab80cfccd4d8e45d557d7b2a1c96a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockFeedView = "card" | "list" | "%future added value";
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FeedDashboardBlockFragment$data = {
  readonly dashboard: {
    readonly app: {
      readonly feed: {
        readonly id: string;
      } | null;
    } | null;
  };
  readonly feedView: DashboardBlockFeedView;
  readonly position: DashboardBlockPosition;
  readonly " $fragmentSpreads": FragmentRefs<"FeedDashboardBlockCardViewFragment" | "FeedDashboardBlockListViewFragment">;
  readonly " $fragmentType": "FeedDashboardBlockFragment";
};
export type FeedDashboardBlockFragment$key = {
  readonly " $data"?: FeedDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": "feedView",
      "args": null,
      "kind": "ScalarField",
      "name": "view",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "dashboard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Feed",
              "kind": "LinkedField",
              "name": "feed",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedDashboardBlockCardViewFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedDashboardBlockListViewFragment"
    }
  ],
  "type": "FeedDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "1ff56e62b0a51e3c634eed3ffbf91525";

export default node;
